import {  useContext } from 'react';
import { IframeContext } from './IframeContext';
export const useIframe = () => {
    const context = useContext(IframeContext);
    if (!context) {
      throw new Error('useIframe must be used within an IframeProvider');
    }
    return context;
  };